import { Temporal } from 'temporal-polyfill';

import { BaseEntityTableGroupKey } from '@/components/table/entity-table';

export interface StartDateGroupKey extends BaseEntityTableGroupKey {
  instant: Temporal.Instant;
  plainDate: Temporal.PlainDate;
  timeZone: string;
}

export function groupByStartDate(startInstant: Temporal.Instant, timeZone: string): StartDateGroupKey {
  const zoned = startInstant.toZonedDateTimeISO(timeZone);
  const plainDate = zoned.toPlainDate();
  return {
    key: plainDate.toString(),
    instant: plainDate.toZonedDateTime(timeZone).toInstant(),
    plainDate,
    timeZone,
  };
}

export interface StartDateTimeRangeGroupKey extends BaseEntityTableGroupKey {
  startInstant: Temporal.Instant;
  endInstant: Temporal.Instant;
  plainDate: Temporal.PlainDate;
  startTime: Temporal.PlainTime;
  endTime: Temporal.PlainTime;
  timeZone: string;
}

export interface SchoolNameGroupKey extends BaseEntityTableGroupKey {
  schoolName: string;
}

export function groupBySchoolName(schoolName: string | undefined): SchoolNameGroupKey {
  const name = schoolName ?? 'Unknown';
  return {
    key: name,
    schoolName: name,
  };
}

export function groupByStartDateAndTimeRange(
  startInstant: Temporal.Instant,
  endInstant: Temporal.Instant,
  timeZone: string,
): StartDateTimeRangeGroupKey {
  const startZoned = startInstant.toZonedDateTimeISO(timeZone);
  const endZoned = endInstant.toZonedDateTimeISO(timeZone);
  const plainDate = startZoned.toPlainDate();
  const startTime = startZoned.toPlainTime();
  const endTime = endZoned.toPlainTime();
  return {
    key: `${plainDate.toString()}_${startTime.toString()}_${endTime.toString()}`,
    startInstant,
    endInstant,
    plainDate,
    startTime,
    endTime,
    timeZone,
  };
}
